// import * as React from 'react';

export const TYPE_NAVIGATION = 'navigation';
export const TYPE_CALENDAR = 'calendar';
export const TYPE_AGENDE = 'agende';
export const TYPE_SCHEDULER = 'scheduler';
export const TYPE_MODIFIER = 'modifier';

export const VIEW_TYPE_YEAR_MULTI_MOUNTH = 'Year multi mounth';
export const VIEW_TYPE_YEAR = 'Year';
export const VIEW_TYPE_MONTH = 'Month';
export const VIEW_TYPE_WEEK = 'Week';
export const VIEW_TYPE_DAY = 'Day';
export const VIEW_TYPE_AGENDE = 'Agende';

export const VIEW_TYPE_MODIFIER_LAYER0 = 'modifier Layer0';
export const VIEW_TYPE_MODIFIER_LAYER1 = 'modifier Layer1';
export const VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH = 'modifier adjustmentToUnitWidth';
export const VIEW_TYPE_MODIFIER_HOURS_MIN_MAX = 'modifier hours min max';

export const ATRYBUT_SCHED_SHOWEXACT ='schedexact';
export const ATRYBUT_SCHED_SHOWFIXED = 'schedfixed';
export const ATRYBUT_SCHED_SHOWYEAR ='schedyear';
export const ATRYBUT_SCHED_SHOWMONTH = 'schedmonth';
export const ATRYBUT_SCHED_SHOWWEEK = 'schedweek';
export const ATRYBUT_SCHED_SHOWDAY = 'schedday';
export const ATRYBUT_SCHED_SHOWAGENDE = 'schedag';

export const footerButtons = [
  {id: 10, type: TYPE_CALENDAR,    name: 'Rok/Mies',  viewType: VIEW_TYPE_YEAR_MULTI_MOUNTH},
  {id: 11, type: TYPE_CALENDAR,    name: 'Rok',       viewType: VIEW_TYPE_YEAR},
  {id: 12, type: TYPE_CALENDAR,    name: 'Miesiąc',   viewType: VIEW_TYPE_MONTH},
  {id: 13, type: TYPE_CALENDAR,    name: 'Tydzień',   viewType: VIEW_TYPE_WEEK}, 
  {id: 14, type: TYPE_CALENDAR,    name: 'Dzień',     viewType: VIEW_TYPE_DAY}, 
  {id: 15, type: TYPE_CALENDAR,    name: 'Agenda',    viewType: VIEW_TYPE_AGENDE}, 

  {id: 20, type: TYPE_AGENDE,      name: 'Rok',       viewType: VIEW_TYPE_YEAR}, 
  {id: 21, type: TYPE_AGENDE,      name: 'Miesiąc',   viewType: VIEW_TYPE_MONTH}, 
  {id: 22, type: TYPE_AGENDE,      name: 'Tydzień',   viewType: VIEW_TYPE_WEEK}, 
  {id: 23, type: TYPE_AGENDE,      name: 'Dzień',     viewType: VIEW_TYPE_DAY},

  {id: 31, type: TYPE_SCHEDULER,   name: 'Rok',       viewType: VIEW_TYPE_YEAR},
  {id: 32, type: TYPE_SCHEDULER,   name: 'Miesiąc',   viewType: VIEW_TYPE_MONTH},
  {id: 33, type: TYPE_SCHEDULER,   name: 'Tydzień',   viewType: VIEW_TYPE_WEEK}, 
  {id: 34, type: TYPE_SCHEDULER,   name: 'Dzień',     viewType: VIEW_TYPE_DAY}, 

  {id: 101, type: TYPE_MODIFIER,   name: 'Layer 0',         viewType: VIEW_TYPE_MODIFIER_LAYER0},
  {id: 102, type: TYPE_MODIFIER,   name: 'Layer 1',         viewType: VIEW_TYPE_MODIFIER_LAYER1},
  {id: 103, type: TYPE_MODIFIER,   name: 'Dokładnie',       viewType: VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH},  
  {id: 104, type: TYPE_MODIFIER,   name: 'Godziny min max', viewType: VIEW_TYPE_MODIFIER_HOURS_MIN_MAX},
];

export const isSelected = (viewButtons, view, type) => {  
  if (view.type !== type) return false;  
  // console.log('...???...isSelected', viewButtons, view, type, Boolean(viewButtons[view.viewType]));
  return Boolean(viewButtons[view.viewType]);
}

export const eventHeight = 24;
export const borderWidth = 1;
export const borderColor = '#00000011';  
export const selectColor = '#00000008';

export const todayBorder = '3px dashed #ff000044';